import extras from './extras.json';
import CrucibleLoader from '../../crucibleLoader';
import * as THREE from 'three';

export default function getCrucibleStickers(
  mintNumber: number,
  loader: CrucibleLoader
): THREE.Object3D[] {
  const crucibleStickers: THREE.Group[] = [];

  // Alien sticker for the first 1000 crucibles
  if (mintNumber > 0 && mintNumber <= 1000) {
    const alienSticker = new THREE.Group();
    alienSticker.name = 'Alien Sticker';
    crucibleStickers.push(alienSticker);

    loader.loadModel(extras.stickers['alien']).then((sticker) => {
      sticker.scene.position.y += 0.2;
      alienSticker.add(sticker.scene);
    });
  }

  return crucibleStickers;
}
